import React from 'react'
import './style.scss'
import vk from '../../assets/images/social/vk.svg'
import fb from '../../assets/images/social/facebook.svg'
import tw from '../../assets/images/social/twitter.svg'
import tg from '../../assets/images/social/telegram.svg'

class SocialSharing extends React.Component {
  componentDidMount() {
    this.factContentElement = document.querySelector('.fact-content')
    if (this.factContentElement) {
      this.factContentDescriptionElement = this.factContentElement.querySelector('.description')
      if (!this.factContentDescriptionElement) {
        this.factContentDescriptionElement = this.factContentElement.querySelector('.quiz')
      }
      this.socialSharingElement = this.factContentElement.querySelector('.social-sharing')

      this.getSocialSharingElementWidth()
      window.addEventListener('resize', this.getSocialSharingElementWidth.bind(this))
    }
  }

  getSocialSharingElementWidth() {
    if (this.socialSharingElement) {
      this.socialSharingElement.style.width = null
      this.socialSharingElement.style.width = this.factContentDescriptionElement.offsetWidth + 'px'
    }
  }

  render() {
    let id = ''
    if (this.props.id) {
      id = this.props.id
    }
    const url = window.location.origin + window.location.pathname + '%23' + window.location.hash.replace('#', '') + id

    const props = this.props
    let mainText = '160 фактов о Центральном Банке России. Что такое «моржовки»? Можно ли расплатиться пятикилограммовой монетой? Узнайте больше об истории денег и работе Центрального Банка.'

    if (this.props.mainText) {
      mainText = ''
      const mainTextProps = this.props.mainText
          .replace(/&nbsp;/g, ' ')
          .replace(/&laquo;/g, '«')
          .replace(/&raquo;/g, '«')
          .replace(/&mdash;/g, '—')
          .substring(0, 200)

      const mainTextSplit = mainTextProps.split(' ')

      for (let i = 0; i < mainTextSplit.length; i++) {
        if ((mainText + mainTextSplit[i]).length > 170) {
          break
        }

        mainText = mainText + mainTextSplit[i] + ' '
      }
    }

    mainText = mainText.trim().replace(/([,!])$/, '') + '...'

    return (
      <div className={["social-sharing" + (props.topIndent ? " top-indent" : "")]}>
        {
          this.props.isQuiz ? <p>Поделиться тестом</p> : ''
        }
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={ "https://vk.com/share.php?title=" + mainText + "&url=" + url }>
          <img src={vk} alt="vk.com"/>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={ "https://facebook.com/share.php?u=" + url }>
          <img src={fb} alt="facebook"/>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={ "https://twitter.com/intent/tweet?text=" + mainText + "&url=" + url }>
          <img src={tw} alt="twitter"/>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={ "https://t.me/share/url?text=" + mainText + "&url=" + url }>
          <img src={tg} alt="telegram"/>
        </a>
      </div>
    )
  }
}

export default SocialSharing
